import { ReactNode } from 'react';
import { Card, mergeClasses } from '@fluentui/react-components';

import { useWidgetContainerStyles } from './WidgetContainer.styles';

export interface WidgetContainerProps {
  className?: string
  title?: string
  children?: ReactNode
  footer?: ReactNode
}

const WidgetContainer: React.FC<WidgetContainerProps> = (props: WidgetContainerProps) => {
  const { className, title, children, footer } = props;
  const classes = useWidgetContainerStyles();
  const renderedTitle = title && <h1 className={classes.title}>{title}</h1>;
  const renderedFooter = footer && <div className={classes.footer}>{footer}</div>;

  return (
    <Card className={mergeClasses('widget-container', classes.wrapper, className)} data-testid="widget-container">
      {renderedTitle}

      <div>{children}</div>

      {renderedFooter}
    </Card>
  );
};

export default WidgetContainer;
